<template>
  <div id="app">

    <v-btn v-if="isHaveReportRight" @click="fetchPdf01" style="align-self: right;">Finans Kasa Banka İcmal</v-btn>
    <v-btn v-if="isHaveReportRight" @click="fetchPdf02" style="align-self: right;">Mevduat Detayı</v-btn>
    <v-btn v-if="isHaveReportRight" @click="fetchPdf03" style="align-self: right;">Kredi Geri Ödeme Tablosu</v-btn>
    <br/>
    <v-btn v-if="isHaveReportRightINS" @click="fetchPdf04" style="align-self: right; background-color: gray;">SUMMA İnşaat Banka İcmal</v-btn>



    <!-- <button @click="fetchPdf01">Finans Kasa Banka İcmal</button>
    <button @click="fetchPdf02">Mevduat Detayı</button>
    <button @click="fetchPdf03">Kredi Geri Ödeme Tablosu</button> -->


    <div v-if="pdfUrl">
      <!-- iframe yerine object etiketi kullanarak -->
      <object :data="pdfUrl" type="application/pdf" width="100%" height="800px">
        <p><a :href="pdfUrl" target="_blank">PDF'yi indir</a></p>
      </object>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['isHaveReportRight']),
    ...mapState(['isHaveReportRightINS'])
  },
  
  data() {
    return {
      pdfUrl: null,
      pdfBlob: null,
      isMobile: false
    };
  },
  methods: {

    async fetchPdf01() {
      try {
        const response = await axios.get('Report/Get01', {
          responseType: 'arraybuffer',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfBlob = blob;
        this.pdfUrl = URL.createObjectURL(blob);

        this.prepareDownload();
      } catch (error) {
        console.error('PDF alınamadı:', error);
      }
    },

    async fetchPdf02() {
      try {
        const response = await axios.get('Report/Get02', {
          responseType: 'arraybuffer',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfBlob = blob;
        this.pdfUrl = URL.createObjectURL(blob);
      
        this.prepareDownload();
      } catch (error) {
        console.error('PDF alınamadı:', error);
      }
    },

    async fetchPdf03() {
      try {
        const response = await axios.get('Report/Get03', {
          responseType: 'arraybuffer',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfBlob = blob;
        this.pdfUrl = URL.createObjectURL(blob);

        this.prepareDownload();
      } catch (error) {
        console.error('PDF alınamadı:', error);
      }
    },

    async fetchPdf04() {
      try {
        const response = await axios.get('Report/Get04', {
          responseType: 'arraybuffer',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfBlob = blob;
        this.pdfUrl = URL.createObjectURL(blob);

        this.prepareDownload();
      } catch (error) {
        console.error('PDF alınamadı:', error);
      }
    },


    downloadPdf() {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.pdfBlob);
      link.setAttribute('download', 'document.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    prepareDownload() {
      // Bu yöntem gerekli blob URL'yi hazırlamak için kullanılabilir
      // Örneğin bir indirme bağlantısı oluşturmak gibi.
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.pdfBlob);
      link.setAttribute('download', 'document.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },

    checkIfMobile() {

      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
    },

    created() {
    this.checkIfMobile();
  }
  },
};
</script>

<style>
/* İsteğe bağlı stil tanımları */
</style>
